export const hexToRgbaString = (hex, a) => {
  const fullHex = hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (_, r, g, b) => r + r + g + g + b + b);
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
  const rgba = result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
  return rgba ? `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}${a ? `, ${a}` : ''})` : 'transparent';
};
//# sourceMappingURL=hexToRgbaString.js.map